import { SidenavItem } from '@layout/sidenav/sidenav-item/sidenav-item.interface';

export const ESIC_ADMIN_SIDENAV_ITEMS: SidenavItem[] = [
  {
    name: 'PRINCIPAL',
    position: 5,
    type: 'subheading',
    customClass: 'first-subheading'
  },
  {
    name: 'Principal',
    routeOrFunction: '/modulo/esic/admin/principal',
    icon: 'home',
    position: 10,
    pathMatchExact: true
  },
  {
    name: 'Consultar pedido',
    routeOrFunction: '/modulo/esic/admin/pedido/consulta',
    icon: 'search',
    position: 20,
  },
  {
    name: 'Consultar recurso',
    routeOrFunction: '/modulo/esic/admin/recurso/consulta',
    icon: 'find_in_page',
    position: 30,
  },
  {
    name: 'Painel de controle',
    routeOrFunction: '/modulo/esic/admin/paineldecontrole',
    icon: 'insert_chart',
    position: 40,
  },
  {
    name: 'Pedidos avulsos',
    icon: 'description',
    position: 50,
    subItems: [
      {
        name: 'Pessoa física',
        routeOrFunction: '/modulo/esic/admin/pedidopf',
        position: 1
      },
      {
        name: 'Pessoa jurídica',
        routeOrFunction: '/modulo/esic/admin/pedidopj',
        position: 2
      },
    ]
  },
  {
    name: 'Pessoa',
    icon: 'people',
    position: 60,
    subItems: [
      {
        name: 'Consulta',
        routeOrFunction: '/modulo/esic/admin/pessoa/consulta',
        position: 1
      },
      {
        name: 'Pessoa jurídica',
        routeOrFunction: '/modulo/esic/admin/pessoajuridica',
        position: 2
      },
      {
        name: 'Pessoa física',
        routeOrFunction: '/modulo/esic/admin/pessoafisica',
        position: 3
      },
    ]
  },
  {
    name: 'Cadastros auxiliares',
    icon: 'library_books',
    position: 70,
    subItems: [
      {
        name: 'Área de interesse',
        routeOrFunction: '/modulo/esic/admin/areadeinteresse/list',
        position: 1
      },
      {
        name: 'Motivo da prorrogação',
        routeOrFunction: '/modulo/esic/admin/motivodaprorrogacao/list',
        position: 2
      },
      {
        name: 'Motivo do recurso',
        routeOrFunction: '/modulo/esic/admin/motivodorecurso/list',
        position: 3
      },
    ]
  },
    {
    name: 'Administração',
    icon: 'settings',
    position: 80,
    subItems: [
      {
        name: 'Configuração',
        routeOrFunction: '/modulo/esic/admin/configuracao',
        position: 1
      },
      {
        name: 'Servidores do e-SIC',
        routeOrFunction: '/modulo/esic/admin/servidor/list',
        position: 2
      },
      {
        name: 'Comissão de avaliação',
        routeOrFunction: '/modulo/esic/admin/comissaodeavaliacao/list',
        position: 3
      },
      {
        name: 'Autoridade superior',
        routeOrFunction: '/modulo/esic/admin/autoridadesuperior',
        position: 4
      },
      {
        name: 'Autoridade máxima',
        routeOrFunction: '/modulo/esic/admin/autoridademaxima',
        position: 5
      },
    ]
  },
];
